import { Component, HostListener } from '@angular/core';
import { VendorService } from '@services/vendor.service';
import { VendorDetails } from '@interfaces/vendor.model';
import { Router, ActivatedRoute } from '@angular/router';
import { quarterlyFeedback, ToastTitle, RoutesEnum } from '@app/shared/constants/global.enum';
import { ToasterService } from '@app/shared/services/toaster.service';

@Component({
  selector: 'app-vendor-rep',
  templateUrl: './vendor-rep.component.html',
  styleUrls: ['./vendor-rep.component.scss'],
})
export class VendorRepComponent {
  vendorName: string = '';
  vendorId: string = '';
  showMenu: boolean = false;
  quarterlyFeedback = quarterlyFeedback;
  routesEnum = RoutesEnum;

  get vendorInitials(): string {
    const parts = (this.vendorName || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '—';
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  
  constructor(
    private vendorService: VendorService,
    private router: Router,
    private route: ActivatedRoute,
    private toasterService: ToasterService
  ) { }

  @HostListener('document:click', ['$event'])
  clickOutside(event: any) {
    const iconContainer = document.querySelector('.icon-container');
    if (iconContainer && !iconContainer.contains(event.target)) {
      this.showMenu = false;
    }
  }

  ngOnInit(): void {
    // Fetch the current vendor details
    this.vendorService.getCurrentVendor().subscribe(
      (vendor: VendorDetails | null | undefined) => {
        if (vendor) {
          if (vendor.name) {
            this.vendorName = vendor.name;
          }
          if (vendor.id) {
            this.vendorId = vendor.id;
          }
        }
      },
      (error: any) => {
        alert('Error fetching vendor details: ' + error.message);
      }
    );
  }
  goToOpenPositions() {
    this.router.navigate(['/vendor/open-positions']);
  }
  private isMenuTogglePending = false;
  private readonly DEBOUNCE_TIME = 300;
  
  toggleMenu(event: Event) {
    event.stopPropagation();
   if (this.isMenuTogglePending) {
      return;
    }
    this.isMenuTogglePending = true;
    this.showMenu = !this.showMenu;
    setTimeout(() => {
      this.isMenuTogglePending = false;
    }, this.DEBOUNCE_TIME);
  }
  
  navigateTo(route: string) {
    if (route === this.routesEnum.quarterlyFeedback) {
      // Validate vendorId is not null, undefined, or empty string before using it
      if (this.vendorId) {
        this.router.navigate([`/${this.routesEnum.vendorFlowRoute}/${this.routesEnum.quarterlyFeedback}`, this.vendorId])
          .then(success => {
            if (!success) {
              this.toasterService.showError(
                quarterlyFeedback.navigationFailed,
                ToastTitle.ERROR
              );
            }
          })
          .catch(error => {
            this.toasterService.showError(
              quarterlyFeedback.navigationError + error.message,
              ToastTitle.ERROR
            );
          });
      } else {
        this.toasterService.showError(
          quarterlyFeedback.noVendorId,
          ToastTitle.ERROR
        );
      }
    } else if (route === this.routesEnum.OpsVendorProfile) {
      if (this.vendorId && this.vendorName) {
        const encodedVendorName = encodeURIComponent(this.vendorName);
        this.router
          .navigate([
            `/${this.routesEnum.vendorFlowRoute}/${this.routesEnum.OpsVendorProfile}`,
            this.vendorId,
            encodedVendorName,
          ])
          .then((success) => {
            if (!success) {
              this.toasterService.showError(
                'Navigation to profile failed',
                ToastTitle.ERROR,
              );
            }
          })
          .catch((error) => {
            this.toasterService.showError(
              'Profile navigation error: ' + error.message,
              ToastTitle.ERROR,
            );
         });
     } else {
       this.toasterService.showError(
         'Vendor ID or name is missing',
         ToastTitle.ERROR,
       );
       }
    }
    this.showMenu = false;
  }
}